import {inject, Injectable} from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@env/environments.llm-dev';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

@Injectable({
  providedIn: 'root'
})
export class TextToSpeechService {
  //Injectbales
  private _console = inject(Tools_aiConsoleService);
  private readonly apiUrl = 'https://texttospeech.googleapis.com/v1beta1/text:synthesize';
  private readonly apiKey = environment.googleTtsApiKey;

  constructor(private http: HttpClient) {}

  /**
   * Sintetiza el texto dado en un archivo de audio MP3.
   * La API de Google Text-to-Speech devuelve el audio codificado en Base64.
   * Por lo tanto, el servicio se encarga de decodificarlo.
   * @param text El texto a sintetizar.
   * @returns Un Observable que emite el ArrayBuffer del audio MP3.
   */
  synthesizeSpeech(text: string): Observable<ArrayBuffer> {
    const requestBody = {
      input: { text },
      voice: {
        languageCode: 'pt-BR',
        name: 'pt-BR-Chirp3-HD-Orus'
      },
      audioConfig: {
        audioEncoding: 'MP3',
        pitch: 0,
        speakingRate: 1
      }
    };

    const params = new HttpParams().set('key', this.apiKey);

    // La API de Google Text-to-Speech devuelve un JSON con audioContent en Base64.
    return this.http.post<any>(this.apiUrl, requestBody, { params }).pipe(
      map(response => {

        if (response && response.audioContent) {
          // Decodificar la cadena Base64 a un ArrayBuffer
          const binaryString = window.atob(response.audioContent);
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
          }
          return bytes.buffer; // Devolve el ArrayBuffer
        } else {
          throw new Error('La respuesta de la API no contiene audioContent.');
        }
      })
    );
  }
}
